define('app/sf/js/string/sf-js-string-filter',[],function () {
	"use strict";
	return jsEscape;
	function jsEscape(value, doubleQuotes) {
		if (value === undefined || value === null)
			value = "";
		var str = String(value);
		if (!str)
			return str;
		return str
			.replace(doubleQuotes ? /(["\\])/g : /(['\\])/g, '\\$1')
			.replace(/[\f]/g, "\\f")
			.replace(/[\b]/g, "\\b")
			.replace(/[\n]/g, "\\n")
			.replace(/[\t]/g, "\\t")
			.replace(/[\r]/g, "\\r")
			.replace(/[\u2028]/g, "\\u2028")
			.replace(/[\u2029]/g, "\\u2029");
	}
});
